// components/search/SearchForm.jsx
import React from 'react';

export default function SearchForm({ zip, setZip, radius, setRadius, sort, setSort, onSearch }) {
  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-4 mt-4">
      {/* Zip Code Input */}
      <input
        type="text"
        placeholder="Enter Zip Code"
        value={zip}
        onChange={(e) => setZip(e.target.value)}
        className="border p-2 rounded w-full sm:w-1/3"
      />

      {/* Radius Dropdown */}
      <div className="flex flex-row gap-4">
      <select
        value={radius}
        onChange={(e) => setRadius(e.target.value)}
        className="border p-2 rounded w-full sm:w-1/3 font-montserrat bg-white"
      >
        <option value="">Select Radius</option>
        {[10, 25, 50, 75, 100, 150, 200].map((r) => (
          <option key={r} value={r}>{r} miles</option>
        ))}
      </select>

      {/* Sort Dropdown */}
      <select
        value={sort}
        onChange={(e) => setSort(e.target.value)}
        className="border p-2 rounded w-full sm:w-1/3 font-montserrat bg-white"
      >
        <option value="" className="font-montserrat">Sort By</option>
        <option value="newest" className="font-montserrat">Newest</option>
        <option value="priceHigh" className="font-montserrat">Price: High to Low</option>
        <option value="priceLow" className="font-montserrat">Price: Low to High</option>
        <option value="alpha" className="font-montserrat">Alphabetical</option>
      </select>
      </div>

      {/* Search Button */}
      <button
        onClick={onSearch}
        className="bg-primary text-white px-4 py-2 rounded font-montserrat"
      >
        Search
      </button>
    </div>
  );
}